import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './lib/appInsights';
import App from './App';
import TelemetryTracker from './components/Common/TelemetryTracker';
import SeoTags from './components/Common/SeoTags';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Polyfill Canvas roundRect for older browsers & WebViews
if (typeof CanvasRenderingContext2D !== 'undefined' && !CanvasRenderingContext2D.prototype.roundRect) {
  CanvasRenderingContext2D.prototype.roundRect = function (x: number, y: number, w: number, h: number, radii?: number | number[]) {
    const r = typeof radii === 'number' ? [radii, radii, radii, radii] : (radii || [0, 0, 0, 0]);
    const r0 = r[0] || 0, r1 = r[1] || 0, r2 = r[2] || 0, r3 = r[3] || 0;
    this.beginPath();
    this.moveTo(x + r0, y);
    this.lineTo(x + w - r1, y);
    this.quadraticCurveTo(x + w, y, x + w, y + r1);
    this.lineTo(x + w, y + h - r2);
    this.quadraticCurveTo(x + w, y + h, x + w - r2, y + h);
    this.lineTo(x + r3, y + h);
    this.quadraticCurveTo(x, y + h, x, y + h - r3);
    this.lineTo(x, y + r0);
    this.quadraticCurveTo(x, y, x + r0, y);
    this.closePath();
    return this;
  };
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AppInsightsContext.Provider value={reactPlugin}>
    <BrowserRouter>
      <TelemetryTracker />
      <SeoTags />
      <App />
    </BrowserRouter>
  </AppInsightsContext.Provider>
);

// PWA : enregistre le service worker (production uniquement).
serviceWorkerRegistration.register();

